// --- 供应点管理 --- //

export default [
  {
    name: "baseReconciliation",
    path: "/supplySystem/:supplyId/supplyCentre/:supplyCentreId/baseReconciliation",
    meta: { title: "基地对账" },
    component:
      require("business/supplySystem/supplyCentreManagement/baseReconciliation/list.vue")
        .default,
  },
  {
    name: "takeDeliveryManagement",
    path: "/supplySystem/:supplyId/supplyCentre/:supplyCentreId/takeDeliveryManagement",
    meta: { title: "领货管理" },
    component:
      require("business/supplySystem/supplyCentreManagement/takeDeliveryManagement/list.vue")
        .default,
  },
  {
    name: "cancelRecord",
    path: "/supplySystem/:supplyId/supplyCentre/:supplyCentreId/cancelRecord",
    meta: { title: "核销记录" },
    component:
      require("business/supplySystem/supplyCentreManagement/cancelRecord/list.vue")
        .default,
  },
  {
    name: "returnRecord",
    path: "/supplySystem/:supplyId/supplyCentre/:supplyCentreId/returnRecord",
    meta: { title: "退货退款记录" },
    component:
      require("business/supplySystem/supplyCentreManagement/returnRecord/list.vue")
        .default,
  },
  {
    name: "supplyCentreTradeInquire",
    path: "/supplySystem/:supplyId/supplyCentre/:supplyCentreId/tradeInquire",
    meta: { title: "交易查询" },
    component:
      require("business/supplySystem/supplyCentreManagement/tradeInquire/list.vue")
        .default,
  },
  {
    name: "supplyCentreTradeInquireDetail",
    path: "/supplySystem/:supplyId/supplyCentre/:supplyCentreId/tradeInquireDetail",
    meta: { title: "交易查询详情" },
    component:
      require("business/supplySystem/supplyCentreManagement/tradeInquire/detail.vue")
        .default,
  },
];
